import 'root/helpers/lazyLoadLibrary';
import {
    defaultComponentMap,
    onLoadComponentMap,
    onClickComponentsCallbacks,
} from 'root/main/components';
import { chunkMapLoop } from 'root/utils/importChunk/chunkMapLoop';
import { CoreDom, CoreLoad, buttonTrackingHandler } from 'root/core';
import AjaxContent from 'root/main/core/ajax/ajaxContent';
import polyfill from 'root/helpers/polyfills/modernBrowsers';
import { trackRestaurantProductIfLinkMatchesHrefSubstring } from 'root/core/restaurantProductTracking/restaurantProductTracking';

// AB TESTS
import loadSwiperForTheme4 from 'root/page/AB_TESTS/AB_TEST_Affiliate_Theme_4';

// polyfill provides js polyfills for certain functions in "modern" browsers, which in our case means browsers that support the "module" attribute
polyfill();

const componentsChunk = ({ dirname, filename }) =>
    import(
        /*webpackChunkName: "[request]"*/ `root/main/components/${dirname}/${filename}`
    );

/******** AJAX ********/
AjaxContent(); // this is to enable the ajax functionality on the site found root/main/core/ajax/ajaxContent
/******** END AJAX ********/

document.addEventListener('DOMContentLoaded', () => {
    CoreDom();

    chunkMapLoop(defaultComponentMap, componentsChunk);
});

window.addEventListener('load', () => {
    CoreLoad();
    chunkMapLoop(onLoadComponentMap, componentsChunk);
});

document.addEventListener('click', e => {
    onClickComponentsCallbacks.forEach(callback => callback(e));
    buttonTrackingHandler(e);
    trackRestaurantProductIfLinkMatchesHrefSubstring(e.target);
});

// AB TESTS
loadSwiperForTheme4();
